
















































































































































































import { BookingDetailsModule } from "@/store/modules/bookingDetails";
import { Component, Vue } from "vue-property-decorator";
import DateTimeUtils from "@/lib/dateTimeUtils";
import GiganautVue from "@/components/Shared/GiganautVue";
import BookingDetailsBookingRoleCreate from '@/components/BookingRoles/BookingDetailsBookingRoleCreate.vue';
import BookingDetailsBookingRoleEdit from '@/components/BookingRoles/BookingDetailsBookingRoleEdit.vue';
import BookingDetailsShiftEdit from '@/components/Shifts/BookingDetailsShiftEdit.vue'
import BookingDetailsShiftCreate from '@/components/Shifts/BookingDetailsShiftCreate.vue'
import { VuetifyConfirmObject } from "vuetify-confirm";
import ShiftDto from "@/models/Shifts/ShiftDto";
import BookingRoleDto from "@/models/BookingRoles/BookingRoleDto";
import BookingRoleStatus from '@/components/BookingRoles/Display/BookingRoleStatus.vue';
import ShiftStatus from '@/components/Shifts/Display/ShiftStatus.vue';
import ShiftCancel from '@/components/Shifts/ShiftCancel.vue';
import BookingRoleCancel from '@/components/BookingRoles/BookingRoleCancel.vue';

@Component({
  name: "BookingRequirements",
  components: { BookingDetailsBookingRoleCreate, BookingDetailsBookingRoleEdit, BookingDetailsShiftCreate, BookingDetailsShiftEdit, BookingRoleStatus, BookingRoleCancel, ShiftCancel, ShiftStatus},
})
export default class extends GiganautVue {
  
  get currentBooking() {
    return BookingDetailsModule.currentBooking;
  }

  get roles() {
    return BookingDetailsModule.currentBooking.roles;
  }

  async deleteShift(shift: ShiftDto) {
    const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this shift?', options);
        if (result) {
            await BookingDetailsModule.deleteShift(shift);
        }
  }

  async deleteBookingRole(bookingRole: BookingRoleDto){
        const options: VuetifyConfirmObject = {
            buttonTrueText: "DELETE",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this role?', options);
        if (result) {
            await BookingDetailsModule.deleteBookingRole(bookingRole);
        }
    } 

  get datesSummary() {
    let dates = "";
    for (let i = 0; i < BookingDetailsModule.currentBooking.dates.length; i++) {
      if (i !== 0) {
        dates += ", ";
      }
      dates += DateTimeUtils.toShortDate(
        new Date(BookingDetailsModule.currentBooking.dates[i].date)
      );
    }
    return dates;
  }
}
